import { install } from '@qcolor/utils/compoent';
import Sketch from './sketch.vue';
Sketch.install = install;
export default Sketch;